module.exports = __webpack_public_path__ + "static/img/industryBanner.efd4b1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industryBanner.jpg
// module id = bsbL
// module chunks = 0